import * as Yup from 'yup'

const validatePassword = Yup.string()
  .min(6, 'A senha deve ter pelo menos 6 caracteres.')
  .matches(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula.')
  .matches(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula.')
  .matches(/\d/, 'A senha deve conter pelo menos um dígito.')
  .matches(/[!@#$%^&*(),.?":{}|<>]/, 'A senha deve conter pelo menos um caractere especial.')

export const userSchema = (id, isAdmin = false) => {
  const vali = Yup.object().shape({
    name: Yup.string().required('Insira um nome'),

    cpfUser: Yup.string().required('Informe um documento'),

    email: Yup.string().when('type', {
      is: () => 'required',
      then: () => Yup.string().required('Informe um e-mail').email('Digite um email válido'),
      otherwise: () => Yup.string().email('Digite um email válido'),
    }),

    phoneUser: Yup.string()
      .required('Insira um número de telefone.')
      .test('phone-validation', function (value) {
        const phoneCode = String(this.parent?.phoneCode ?? '')
          .replace(/\D/g, '')
          .replace(/^0+/, '')

        if (!value) {
          return this.createError({
            message: 'Insira um número de telefone.',
          })
        }

        // Brasil
        if (phoneCode === '55' || phoneCode === '0055') {
          const numbers = value.replace(/\D/g, '')
          if (numbers.length < 10 || numbers.length > 11) {
            return this.createError({
              message:
                'Insira um número de telefone válido no formato (XX) XXXX-XXXX ou (XX) XXXXX-XXXX.',
            })
          }

          return true
        }

        // Outros países
        const numbers = value.replace(/\D/g, '')

        if (numbers.length < 7 || numbers.length > 17) {
          return this.createError({
            message: 'O telefone deve possuir entre 7 e 17 números.',
          })
        }

        return true
      }),

    roles: Yup.array()
      .min(1, 'Selecione pelo menos um item')
      .required('Selecione o nível de acesso'),

    franchises: Yup.array().min(1, 'Selecione pelo menos um item').required('Selecione a unidade'),

    newPassWord: Yup.string().when('password', {
      is: (val) => val > '0',
      then: () =>
        Yup.string()
          .oneOf([Yup.ref('password')], 'As senhas devem coincidir.')
          .required('Confirmação de senha é obrigatória.'),
    }),
  })

  // No admin, CPF/telefone são opcionais e a senha não tem regras de complexidade
  if (isAdmin) {
    const adminVali = vali.shape({
      cpfUser: Yup.string().nullable(),
      phoneUser: Yup.string().nullable(),
    })
    return adminVali.shape({
      password: id ? Yup.string() : Yup.string().required('Insira uma senha'),
    })
  }

  if (id) {
    return vali.shape({password: validatePassword})
  } else {
    return vali.shape({password: validatePassword.required('Insira uma senha')})
  }
}
